import packageJson from '../package.json';

const parseEnvInt = (value, fallback) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};


const buildApiBaseUrl = (rootUrl, version) => {
  if (!rootUrl) {
    return rootUrl;
  }

  const trimmedRoot = String(rootUrl).replace(/\/+$/, '');
  const trimmedVersion = String(version || '').replace(/^\/+|\/+$/g, '');

  if (!trimmedVersion) {
    return trimmedRoot;
  }

  // Avoid duplicating the version when the root URL already includes it.
  if (trimmedRoot.endsWith(`/${trimmedVersion}`)) {
    return trimmedRoot;
  }

  return `${trimmedRoot}/${trimmedVersion}`;
};

const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL;
const API_VERSION = (process.env.REACT_APP_API_VERSION || '').trim();

const config = {
  // API Configuration
  // API_ROOT_URL is the version-agnostic root (e.g. https://host/api).
  // API_VERSION is the centrally configured version segment (e.g. "v1"), empty for legacy.
  // API_BASE_URL is the composed base every module consumes; never hardcode the version elsewhere.
  API_ROOT_URL,
  API_VERSION,
  API_BASE_URL: buildApiBaseUrl(API_ROOT_URL, API_VERSION),
  
  // Environment
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  
  // Feature Flags (example)
  ENABLE_LOGGING: process.env.REACT_APP_ENABLE_LOGGING === 'true',
  
  // Add other configuration variables as needed
  APP_NAME: process.env.REACT_APP_NAME || 'Cognior Admin',
  APP_VERSION: process.env.REACT_APP_VERSION || packageJson.version || '1.0.0',

  // Auth/session timing (milliseconds)
  AUTH_INACTIVITY_TIMEOUT_MS: parseEnvInt(process.env.REACT_APP_AUTH_INACTIVITY_TIMEOUT_MS, 15 * 60 * 1000),
  AUTH_CHECK_INTERVAL_MS: parseEnvInt(process.env.REACT_APP_AUTH_CHECK_INTERVAL_MS, 30 * 1000),
  AUTH_REFRESH_BEFORE_MS: parseEnvInt(process.env.REACT_APP_AUTH_REFRESH_BEFORE_MS, 60 * 1000),
};

// Validate required configurations
const validateConfig = () => {
  const requiredVars = ['API_BASE_URL'];
  const missing = requiredVars.filter(key => !config[key]);
  
  if (missing.length > 0) {
    console.error(`Missing required environment variables: ${missing.join(', ')}`);
  }
};

// Run validation
validateConfig();

// Freeze config to prevent modifications
export default Object.freeze(config);